import { Component, registerComponent } from 'js/component.js';
import { getBreakpointMediaQuery } from 'js/constants.js';
import gsap from 'gsap';

const componentName = 'quick-links';

/**
 * Quick Links
 */
export class QuickLinks extends Component {

    elements = {
        container: this.element.querySelector(`.${componentName}__container`),
        mobileHeader: this.element.querySelector(`.${componentName}__mobile-header`),
        wrapper: this.element.querySelector(`.${componentName}__wrapper`),
    };

    // [LEGACY BREAKPOINT: max-width 48em -> getBreakpointMediaQuery('down', 'small')]
    matchMobile = getBreakpointMediaQuery('down', 'small');

    /**
     * Initialize Mobile Dropdown
     */
    initMobileDropdown = () => {
        if (this.matchMobile.matches && !this.elements.mobileHeader.classList.contains('active')) {
            gsap.set(this.elements.wrapper, { display: 'none' });
        } else {
            gsap.set(this.elements.wrapper, {
                display: '',
                height: 'auto'
            });
        }
    };

    /**
     * Add Homepage Class to Container
     */
    initHomepageClass = () => {
        if (this.elements.container.classList.contains('homepage-design')) {
            this.element.classList.add('homepage-design');
        }
    };

    /**
     * GSAP slideUp animation
     */
    slideUp = (element, duration = 0.3) => {
        const height = element.offsetHeight;

        gsap.set(element, {
            height,
            overflow: 'hidden'
        });

        gsap.to(element, {
            height: 0,
            duration,
            ease: 'power2.out',
            overwrite: 'auto',
            onComplete: () => {
                gsap.set(element, {
                    display: 'none',
                    height: 'auto',
                    overflow: ''
                });
            }
        });
    };

    /**
     * GSAP slideDown animation
     */
    slideDown = (element, duration = 0.3) => {
        gsap.set(element, {
            display: 'inline-block',
            height: 'auto',
            overflow: 'hidden'
        });

        const height = element.offsetHeight;
        gsap.set(element, { height: 0 });

        gsap.to(element, {
            height,
            duration,
            ease: 'power2.out',
            overwrite: 'auto',
            onComplete: () => {
                gsap.set(element, {
                    height: 'auto',
                    overflow: ''
                });
            }
        });
    };

    /**
     * Handle Dropdown Open/Close
     */
    toggleMobileLinks = () => {
        if (this.elements.mobileHeader.classList.contains('active')) {
            this.elements.mobileHeader.classList.remove('active');
            this.slideUp(this.elements.wrapper);
        } else {
            this.elements.mobileHeader.classList.add('active');
            this.slideDown(this.elements.wrapper);
        }
    };

    addEventListeners = () => {
        this.elements.mobileHeader.addEventListener('click', this.toggleMobileLinks);
        this.matchMobile.addEventListener('change', this.initMobileDropdown);
        document.addEventListener('click', (event) => {
            if (!this.elements.container.contains(event.target) && this.elements.mobileHeader.classList.contains('active')) {
                this.elements.mobileHeader.classList.remove('active');
                this.slideUp(this.elements.wrapper);
            }
        });
    };

    /**
     * Initialize Component
     */
    init() {
        if (this.elements.container.classList.contains('homepage-design')) {
            this.addEventListeners();
            this.initMobileDropdown();
            this.initHomepageClass();
        }
    }
}

registerComponent(`.${componentName}`, QuickLinks);
